import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction, ScreenType } from '@/types/analytics';

import type { AnalyticsSettings } from './analyticsSettings';

/** Send analytics for generation start */
const sendGenerateStartAnalytics = (settings: AnalyticsSettings) => {
  sendAiGenScreenActionAnalytics({
    action: AiGenScreenAction.GENERATE,
    screen_type: ScreenType.GENERATOR,
    settings,
  });
};

export default sendGenerateStartAnalytics;
